import Img_01 from "../img/01.webp"
import Img_02 from "../img/02.webp"
import Img_04 from "../img/04.jpg"
import Img_05 from "../img/05.jpg"
import Img_06 from "../img/06.webp"
import Img_6b6141_hapAC from "../img/6b6141_hapAC.jpg"
import Img_15Mbps from "../img/15Mbps.png"
import Img_24b430ee8499629da5aefc5328002529 from "../img/24b430ee8499629da5aefc5328002529.png"
import Img_30Mbps from "../img/30Mbps.png"
import Img_80Mbps from "../img/80Mbps.png"
import Img_100Mbps from "../img/100Mbps.png"
import Img_250Mbps from "../img/250Mbps.png"
import Img_8327trguyw from "../img/8327trguyw.jpg"
import Img_android_7443fa from "../img/android-7443fa.png"
import Img_atop_logo_sm from "../img/atop-logo-sm.png"
import Img_atop from "../img/atop.png"
import Img_base_package_tv_lg from "../img/base-package-tv-lg.png"
import Img_base_package_tv from "../img/base-package-tv.png"
import Img_basic_channel_logos from "../img/basic-channel-logos.png"
import Img_basic_channels from "../img/basic-channels.png"
import Img_best_gear from "../img/best-gear.jpg"
import Img_bg_account from "../img/bg-account.jpg"
import Img_canfone_logo_white from "../img/canfone-logo-white.png"
import Img_canfone_logo_xs from "../img/canfone-logo-xs.png"
import Img_cms from "../img/cms.png"
import Img_credit_cards_872Y from "../img/credit-cards-872Y.png"
import Img_devices_200 from "../img/devices-200.png"
import Img_download_200 from "../img/download-200.png"
import Img_download_500 from "../img/download-500.png"
import Img_download_800 from "../img/download-800.png"
import Img_family_tv_8E6152AD1267 from "../img/family-tv-8E6152AD1267.jpg"
import Img_firestick_8273g from "../img/firestick-8273g.png"
import Img_firestick_football from "../img/firestick-football.jpg"
import Img_firestick_hockey from "../img/firestick-hockey.jpg"
import Img_gauge_level_01 from "../img/gauge-level-01.png"
import Img_gauge_level_02 from "../img/gauge-level-02.png"
import Img_gauge_level_03 from "../img/gauge-level-03.png"
import Img_GS_HT801_8723gb from "../img/GS-HT801_8723gb.png"
import Img_hero_internet from "../img/hero-internet.jpg"
import Img_hero_landing from "../img/hero-landing.jpg"
import Img_hero_phone from "../img/hero-phone.jpg"
import Img_hero_tv from "../img/hero-tv.jpg"
import Img_icon_fast_bw_gif from "../img/icon-fast-bw.gif"
import Img_icon_fast_bw_png from "../img/icon-fast-bw.png"
import Img_icon_fast from "../img/icon-fast.png"
import Img_icon_gear_bw_gif from "../img/icon-gear-bw.gif"
import Img_icon_gear_bw_png from "../img/icon-gear-bw.png"
import Img_icon_gear from "../img/icon-gear.png"
import Img_icon_globe from "../img/icon-globe.png"
import Img_icon_number from "../img/icon-number.png"
import Img_icon_phone from "../img/icon-phone.png"
import Img_icon_unlimited_bw_gif from "../img/icon-unlimited-bw.gif"
import Img_icon_unlimited_bw_png from "../img/icon-unlimited-bw.png"
import Img_icon_unlimited from "../img/icon-unlimited.png"
import Img_infinity_500 from "../img/infinity-500.png"
import Img_logo_120 from "../img/logo_120.png"
import Img_logo_150 from "../img/logo_150.png"
import Img_logo_on_white from "../img/logo-on-white.png"
import Img_logo_sm from "../img/logo-sm.png"
import Img_logo from "../img/logo.png"
import Img_mikrotik_hap_723tt from "../img/mikrotik-hap-723tt.jpg"
import Img_mikrotik_hap_724tt from "../img/mikrotik-hap-724tt.jpg"
import Img_mini_hero_hardware from "../img/mini-hero-hardware.jpg"
import Img_mini_hero_internet from "../img/mini-hero-internet.jpg"
import Img_mini_hero_phone from "../img/mini-hero-phone.jpg"
import Img_mini_hero_service_details from "../img/mini-hero-service_details.jpg"
import Img_mini_hero_tv from "../img/mini-hero-tv.jpg"
import Img_network_drop_cable from "../img/network-drop-cable.png"
import Img_network_drop_dsl from "../img/network-drop-dsl.png"
import Img_network_drop_none from "../img/network-drop-none.png"
import Img_network_drop_unknown from "../img/network-drop-unknown.png"
import Img_office from "../img/office.jpg"
import Img_phone_booths from "../img/phone_booths.jpg"
import Img_phone_72gtg from "../img/phone-72gtg.jpg"
import Img_phone_canada_us_btn from "../img/phone-canada_us-btn.png"
import Img_phone_canada_btn from "../img/phone-canada-btn.png"
import Img_phone_world_btn from "../img/phone-world-btn.png"
import Img_roku_8273ggs from "../img/roku-8273ggs.png"
import Img_sitting_on_sofa from "../img/sitting_on_sofa.jpg"
import Img_speed_1 from "../img/speed-1.png"
import Img_speed_5 from "../img/speed-5.png"
import Img_speed_6 from "../img/speed-6.png"
import Img_speed_7 from "../img/speed-7.png"
import Img_speed_10 from "../img/speed-10.png"
import Img_speed_15 from "../img/speed-15.png"
import Img_speed_25 from "../img/speed-25.png"
import Img_speed_30 from "../img/speed-30.png"
import Img_speed_40 from "../img/speed-40.png"
import Img_speed_50 from "../img/speed-50.png"
import Img_speed_60 from "../img/speed-60.png"
import Img_speed_75 from "../img/speed-75.png"
import Img_speed_90 from "../img/speed-90.png"
import Img_speed_100 from "../img/speed-100.png"
import Img_speed_120 from "../img/speed-120.png"
import Img_speed_150 from "../img/speed-150.png"
import Img_speed_200 from "../img/speed-200.png"
import Img_speed_250 from "../img/speed-250.png"
import Img_speed_300 from "../img/speed-300.png"
import Img_speed_360 from "../img/speed-360.png"
import Img_speed_400 from "../img/speed-400.png"
import Img_speed_1000 from "../img/speed-1000.png"
import Img_speed_gauge_01_or from "../img/speed-gauge-01-or.png"
import Img_speed_gauge_01_tr from "../img/speed-gauge-01-tr.png"
import Img_speed_gauge_01 from "../img/speed-gauge-01.png"
import Img_speed_gauge_02_or from "../img/speed-gauge-02-or.png"
import Img_speed_gauge_02_tr from "../img/speed-gauge-02-tr.png"
import Img_speed_gauge_02 from "../img/speed-gauge-02.png"
import Img_speed_gauge_03_or from "../img/speed-gauge-03-or.png"
import Img_speed_gauge_03_tr from "../img/speed-gauge-03-tr.png"
import Img_speed_gauge_03 from "../img/speed-gauge-03.png"
import Img_speed_upload from "../img/speed-upload.png"
import Img_tach_level_01 from "../img/tach-level-01.png"
import Img_tach_level_02 from "../img/tach-level-02.png"
import Img_tach_level_03 from "../img/tach-level-03.png"
import Img_tach_level_04 from "../img/tach-level-04.png"
import Img_tach_level_05 from "../img/tach-level-05.png"
import Img_tach_level_06 from "../img/tach-level-06.png"
import Img_tc4300_hapAC from "../img/tc4300_hapAC.jpg"
import Img_tv_display from "../img/tv_display.jpg"
import Img_tv_landing from "../img/tv-landing.jpg"
import Img_unlimited_usage from "../img/unlimited-usage.jpg"
import Img_usage_unlimited from "../img/usage-unlimited.png"
import Img_wicked_fast from "../img/wicked-fast.jpg"

export const GATSBY_IMGS = {
  "img/01.webp" : Img_01,
  "img/02.webp" : Img_02,
  "img/04.jpg" : Img_04,
  "img/05.jpg" : Img_05,
  "img/06.webp" : Img_06,
  "img/6b6141_hapAC.jpg" : Img_6b6141_hapAC,
  "img/15Mbps.png" : Img_15Mbps,
  "img/24b430ee8499629da5aefc5328002529.png" : Img_24b430ee8499629da5aefc5328002529,
  "img/30Mbps.png" : Img_30Mbps,
  "img/80Mbps.png" : Img_80Mbps,
  "img/100Mbps.png" : Img_100Mbps,
  "img/250Mbps.png" : Img_250Mbps,
  "img/8327trguyw.jpg" : Img_8327trguyw,
  "img/android-7443fa.png" : Img_android_7443fa,
  "img/atop-logo-sm.png" : Img_atop_logo_sm,
  "img/atop.png" : Img_atop,
  "img/base-package-tv-lg.png" : Img_base_package_tv_lg,
  "img/base-package-tv.png" : Img_base_package_tv,
  "img/basic-channel-logos.png" : Img_basic_channel_logos,
  "img/basic-channels.png" : Img_basic_channels,
  "img/best-gear.jpg" : Img_best_gear,
  "img/bg-account.jpg" : Img_bg_account,
  "img/canfone-logo-white.png" : Img_canfone_logo_white,
  "img/canfone-logo-xs.png" : Img_canfone_logo_xs,
  "img/cms.png" : Img_cms,
  "img/credit-cards-872Y.png" : Img_credit_cards_872Y,
  "img/devices-200.png" : Img_devices_200,
  "img/download-200.png" : Img_download_200,
  "img/download-500.png" : Img_download_500,
  "img/download-800.png" : Img_download_800,
  "img/family-tv-8E6152AD1267.jpg" : Img_family_tv_8E6152AD1267,
  "img/firestick-8273g.png" : Img_firestick_8273g,
  "img/firestick-football.jpg" : Img_firestick_football,
  "img/firestick-hockey.jpg" : Img_firestick_hockey,
  "img/gauge-level-01.png" : Img_gauge_level_01,
  "img/gauge-level-02.png" : Img_gauge_level_02,
  "img/gauge-level-03.png" : Img_gauge_level_03,
  "img/GS-HT801_8723gb.png" : Img_GS_HT801_8723gb,
  "img/hero-internet.jpg" : Img_hero_internet,
  "img/hero-landing.jpg" : Img_hero_landing,
  "img/hero-phone.jpg" : Img_hero_phone,
  "img/hero-tv.jpg" : Img_hero_tv,
  "img/icon-fast-bw.gif" : Img_icon_fast_bw_gif,
  "img/icon-fast-bw.png" : Img_icon_fast_bw_png,
  "img/icon-fast.png" : Img_icon_fast,
  "img/icon-gear-bw.gif" : Img_icon_gear_bw_gif,
  "img/icon-gear-bw.png" : Img_icon_gear_bw_png,
  "img/icon-gear.png" : Img_icon_gear,
  "img/icon-globe.png" : Img_icon_globe,
  "img/icon-number.png" : Img_icon_number,
  "img/icon-phone.png" : Img_icon_phone,
  "img/icon-unlimited-bw.gif" : Img_icon_unlimited_bw_gif,
  "img/icon-unlimited-bw.png" : Img_icon_unlimited_bw_png,
  "img/icon-unlimited.png" : Img_icon_unlimited,
  "img/infinity-500.png" : Img_infinity_500,
  "img/logo_120.png" : Img_logo_120,
  "img/logo_150.png" : Img_logo_150,
  "img/logo-on-white.png" : Img_logo_on_white,
  "img/logo-sm.png" : Img_logo_sm,
  "img/logo.png" : Img_logo,
  "img/mikrotik-hap-723tt.jpg" : Img_mikrotik_hap_723tt,
  "img/mikrotik-hap-724tt.jpg" : Img_mikrotik_hap_724tt,
  "img/mini-hero-hardware.jpg" : Img_mini_hero_hardware,
  "img/mini-hero-internet.jpg" : Img_mini_hero_internet,
  "img/mini-hero-phone.jpg" : Img_mini_hero_phone,
  "img/mini-hero-service_details.jpg" : Img_mini_hero_service_details,
  "img/mini-hero-tv.jpg" : Img_mini_hero_tv,
  "img/network-drop-cable.png" : Img_network_drop_cable,
  "img/network-drop-dsl.png" : Img_network_drop_dsl,
  "img/network-drop-none.png" : Img_network_drop_none,
  "img/network-drop-unknown.png" : Img_network_drop_unknown,
  "img/office.jpg" : Img_office,
  "img/phone_booths.jpg" : Img_phone_booths,
  "img/phone-72gtg.jpg" : Img_phone_72gtg,
  "img/phone-canada_us-btn.png" : Img_phone_canada_us_btn,
  "img/phone-canada-btn.png" : Img_phone_canada_btn,
  "img/phone-world-btn.png" : Img_phone_world_btn,
  "img/roku-8273ggs.png" : Img_roku_8273ggs,
  "img/sitting_on_sofa.jpg" : Img_sitting_on_sofa,
  "img/speed-1.png" : Img_speed_1,
  "img/speed-5.png" : Img_speed_5,
  "img/speed-6.png" : Img_speed_6,
  "img/speed-7.png" : Img_speed_7,
  "img/speed-10.png" : Img_speed_10,
  "img/speed-15.png" : Img_speed_15,
  "img/speed-25.png" : Img_speed_25,
  "img/speed-30.png" : Img_speed_30,
  "img/speed-40.png" : Img_speed_40,
  "img/speed-50.png" : Img_speed_50,
  "img/speed-60.png" : Img_speed_60,
  "img/speed-75.png" : Img_speed_75,
  "img/speed-90.png" : Img_speed_90,
  "img/speed-100.png" : Img_speed_100,
  "img/speed-120.png" : Img_speed_120,
  "img/speed-150.png" : Img_speed_150,
  "img/speed-200.png" : Img_speed_200,
  "img/speed-250.png" : Img_speed_250,
  "img/speed-300.png" : Img_speed_300,
  "img/speed-360.png" : Img_speed_360,
  "img/speed-400.png" : Img_speed_400,
  "img/speed-1000.png" : Img_speed_1000,
  "img/speed-gauge-01-or.png" : Img_speed_gauge_01_or,
  "img/speed-gauge-01-tr.png" : Img_speed_gauge_01_tr,
  "img/speed-gauge-01.png" : Img_speed_gauge_01,
  "img/speed-gauge-02-or.png" : Img_speed_gauge_02_or,
  "img/speed-gauge-02-tr.png" : Img_speed_gauge_02_tr,
  "img/speed-gauge-02.png" : Img_speed_gauge_02,
  "img/speed-gauge-03-or.png" : Img_speed_gauge_03_or,
  "img/speed-gauge-03-tr.png" : Img_speed_gauge_03_tr,
  "img/speed-gauge-03.png" : Img_speed_gauge_03,
  "img/speed-upload.png" : Img_speed_upload,
  "img/tach-level-01.png" : Img_tach_level_01,
  "img/tach-level-02.png" : Img_tach_level_02,
  "img/tach-level-03.png" : Img_tach_level_03,
  "img/tach-level-04.png" : Img_tach_level_04,
  "img/tach-level-05.png" : Img_tach_level_05,
  "img/tach-level-06.png" : Img_tach_level_06,
  "img/tc4300_hapAC.jpg" : Img_tc4300_hapAC,
  "img/tv_display.jpg" : Img_tv_display,
  "img/tv-landing.jpg" : Img_tv_landing,
  "img/unlimited-usage.jpg" : Img_unlimited_usage,
  "img/usage-unlimited.png" : Img_usage_unlimited,
  "img/wicked-fast.jpg" : Img_wicked_fast,
} 

export const Img__download_200              = Img_download_200;
export const Img__download_500              = Img_download_500;
export const Img__download_800              = Img_download_800;
export const Img__infinity_500              = Img_infinity_500;
export const Img__devices_200               = Img_devices_200;
export const Img__mikrotik_hap_724tt        = Img_mikrotik_hap_724tt;
export const Img__family_tv_8E6152AD1267    = Img_family_tv_8E6152AD1267;
export const Img__phone_72gtg               = Img_phone_72gtg;
export const Img__canfone_logo_white        = Img_canfone_logo_white;
export const Img__speed_upload              = Img_speed_upload;
export const Img__usage_unlimited           = Img_usage_unlimited;
